<script setup lang="ts">
  import { computed } from 'vue';

  import { Badge } from '@ui/components/badge';
  import type { BadgeVariants } from '@ui/components/badge';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';
  import { cn } from '@ui/utils/utils';

  interface Props {
    size?: BadgeVariants['size'];
    type: 'call' | 'email';
    variant?: BadgeVariants['variant'];
    withLabel?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), { variant: 'secondary' });

  const label = computed(() => (props.type === 'email' ? 'Email' : 'Call'));
</script>

<template>
  <Tooltip :disabled="withLabel">
    <TooltipTrigger>
      <Badge
        v-bind="$attrs"
        :variant
        :size
        :class="
          cn(
            'p-1 text-center items-center flex flex-row justify-center gap-1',
            !withLabel && 'rounded-full',
          )
        "
      >
        <i
          :class="
            cn(
              'fa far',
              size === 'xs' && 'text-3xs!',
              type === 'email' ? ' fa-envelope' : ' fa-phone',
            )
          "
        />
        <span v-if="withLabel"> {{ label }} </span>
      </Badge>
    </TooltipTrigger>

    <TooltipContent> {{ label }} </TooltipContent>
  </Tooltip>
</template>

<style scoped></style>
